<template>
	<div class="booking-form">
		<!-- Plugin stepper header (hidden) -->
		<v-stepper :steps="stepCount" v-model="currentIndex" ref="stepper"></v-stepper>
		<!-- Stepper contents -->
		<div class="booking-stepper" :class="{'is-transitioning' : isTransitioning}">
			<transition-group
				:name="transitionDirection"
				@before-leave="beforeTransition"
				@after-enter="afterTransition"
			>
				<JourneyStep v-show="currentStep === 'Journey'" key="Journey" @next="next" />
				<OperatorsStep v-show="currentStep === 'Operators'" key="Operators" @prev="prev" @next="next" />
				<SummaryStep v-show="currentStep === 'Summary'" key="Summary" @prev="prev" @next="next" />
				<ConfirmationStep v-show="currentStep === 'Confirmation'" key="Confirmation" />
			</transition-group>
		</div>
	</div>
</template>

<script>
import { VStepper } from "vue-stepper-component"
import JourneyStep from "@/components/booking/form/steps/JourneyStep"
import OperatorsStep from "@/components/booking/form/steps/OperatorsStep"
import SummaryStep from "@/components/booking/form/steps/SummaryStep"
import ConfirmationStep from "@/components/booking/form/steps/ConfirmationStep"
import { mapGetters } from "vuex"

export default {
	name: "BookingStepper",

	components: { VStepper, JourneyStep, OperatorsStep, SummaryStep, ConfirmationStep },

	data: () => ({
		currentIndex: 1,
		isTransitioning: false,
		transitionDirection: "",
	}),

	computed: {
		...mapGetters("auth", ["isLoggedIn"]),
		...mapGetters("browser", ["isMobile"]),

		stepArray() {
			return [JourneyStep, OperatorsStep, SummaryStep, ConfirmationStep]
		},

		stepCount() {
			return this.stepArray.length
		},

		currentStep() {
			let currentStep
			switch (this.currentIndex) {
				case 1:
					currentStep = "Journey"
					break
				case 2:
					currentStep = "Operators"
					break
				case 3:
					currentStep = "Summary"
					break
				case 4:
					currentStep = "Confirmation"
					break
			}
			return currentStep
		},
	},

	watch: {
		/**
		 * Prevent stepper from being able to go past the last step
		 */
		currentIndex() {
			if (this.currentIndex > this.stepCount) this.currentIndex = this.stepCount
		},
	},

	methods: {
		/**
		 * Set the maximum height for subsequent steps to intital stepper height.
		 */
		setStepperHeightCssProperty() {
			let stepper = document.querySelector(".booking-stepper")
			document.documentElement.style.setProperty("--calculated-stepper-height", stepper.offsetHeight + "px")
		},

		prev() {
			if (this.currentIndex === 1) return
			this.transitionDirection = "prev"
			this.currentIndex--
		},

		next() {
			if (this.currentIndex === this.stepCount) return
			this.transitionDirection = "next"
			this.currentIndex++
		},

		/**
		 * Add flag to hide any overflow on transition,
		 * and ensure the form is scrolled into view.
		 */
		beforeTransition() {
			this.isTransitioning = true

			const site = document.querySelector('.site')
			const siteContentTop = document.querySelector('.site-content').getBoundingClientRect().top
			const formTop = document.querySelector(".booking-form").getBoundingClientRect().top
			const navHeight = document.querySelector(".navbar").offsetHeight
			const position = (this.isMobile)
				? Math.abs(siteContentTop - formTop + navHeight)
				: 0

			site.scrollTo({ top: position, behavior: 'smooth' })
		},


		/**
		 * Remove flag so that any overflow is visible
		 */
		afterTransition() {
			this.isTransitioning = false
		},
	},

	mounted() {
		this.setStepperHeightCssProperty()
		this.$on("prev", this.transitionStep)
		this.$on("next", this.transitionStep)

		// let form = document.querySelector(".booking-form")
		// document.querySelector('.site').addEventListener( 'scroll', () => console.log(offset(form).top) )
	},
}
</script>

<style lang="scss">
// Non-scoped css custom properties
:root {
	--calculated-stepper-height: auto;
	--stepper-padding: 0px;
	@media screen and (min-width: $width-tablet-medium) {
		--stepper-padding: var(--container-padding);
	}
}
</style>

<style lang="scss" scoped>
.booking-form {
	padding: var(--stepper-padding);
	position: relative;
	transition: height 300ms;
	width: 100%;
	z-index: 1;
	@media screen and (min-width: $width-tablet-medium) {
		margin-left: auto;
		padding-right: 0;
		width: 24rem;
	}
	@media screen and (min-width: $width-tablet-large) {
		width: 25rem;
	}

	/deep/ .step-header {
		margin-bottom: 1.5rem;
	}

	/deep/ .step-title {
		line-height: 1.1;
	}
}

.booking-stepper {
	background: #fff;
	height: 100%;
	// Round corners and add shadow when the form is floating
	@media screen and (min-width: $width-tablet-medium) {
		border-radius: 0.25rem;
		box-shadow: $shadow-medium;
	}
	// Hide the overflow when stepper is transitioning
	&.is-transitioning {
		overflow: hidden;
		position: relative;
	}
}

// Hide the stepper header
.v-stepper {
	display: none;
}

// Next transition
.next-enter {
	opacity: 0;
	transform: translateX(100%);
	transition: all 450ms;
}
.next-enter-to {
	opacity: 1;
	transform: translateX(0);
	transition: all 450ms;
}
.next-leave-active {
	height: 100%;
	opacity: 0;
	position: absolute;
	transform: translateX(-100%);
	transition: all 450ms;
	top: 0;
	width: 100%;
}
// Next transition
.prev-enter {
	opacity: 0;
	transform: translateX(-100%);
	transition: all 450ms;
}
.prev-enter-to {
	opacity: 1;
	transform: translateX(0);
	transition: all 450ms;
}
.prev-leave-active {
	height: 100%;
	opacity: 0;
	position: absolute;
	transform: translateX(100%);
	transition: all 450ms;
	top: 0;
	width: 100%;
}
</style>
